import React, {
	useState, useRef, useEffect, useMemo,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { GreenroomState } from '../../stores/types/types';
import { GraphicInterface } from '../../stores/reducers/graphics';
import { HIDE_GRAPHIC_MODAL, editGraphicsAction, updateGraphicsAction } from '../../stores/actions/graphics';
import { isVideo } from '../../utils/utils';
import ButtonClose from '../general-components/button-close';
import { checkFileName } from '../../utils/media';

interface OwnProps {
	graphicForGraphicModal: GraphicInterface;
}

export default function CustomGraphicsModal(props: OwnProps) {
	const { graphicForGraphicModal } = props;

	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);
	const token = useSelector((state: GreenroomState) => state.SessionReducer.token);
	const host = useSelector((state: GreenroomState) => state.SessionReducer.host);

	const [graphic, setGraphic] = useState<GraphicInterface>(graphicForGraphicModal);

	const dispatch = useDispatch();
	const graphicTitleInputRef = useRef<HTMLInputElement | null>(null);
	const videoEl = useRef<HTMLVideoElement | null>(null);

	function closeModal() {
		dispatch({
			type: HIDE_GRAPHIC_MODAL,
			payload: true,
		});
	}

	function updateGraphic(e: any) {
		if (graphic && checkFileName(e?.target.value)) {
			dispatch(editGraphicsAction(token!, {
				...graphic,
				title: e?.target
					? e.target.value
					: graphic.title,
			}, (editedGraphics: GraphicInterface) => {
				dispatch(updateGraphicsAction(editedGraphics));
			}));
		}
	}

	useEffect(() => {
		if (videoEl.current && Boolean(graphic.loops) && videoEl.current.paused) {
			videoEl.current.play();
		}
	}, [graphic]);

	useEffect(() => {
		setGraphic(graphicForGraphicModal);
		if (graphicTitleInputRef.current) {
			graphicTitleInputRef.current.value = graphicForGraphicModal.title;
		}
	}, [graphicForGraphicModal]);

	const isCreatorOrProducer = useMemo(
		() => (
			graphic.created_by === user?.gr_user
			|| graphic.created_by === user?.brandlive_profile
			|| host
		),
		[graphic, user, host],
	);

	return (
		<>
			<div className="media-modal" style={{ height: 'auto' }}>
				<div className="media-modal-top">
					<input
						ref={graphicTitleInputRef}
						type="text"
						onBlur={updateGraphic}
						className={classNames('name', !isCreatorOrProducer && 'not-creator')}
						defaultValue={graphic?.title ?? graphic?.original_name ?? ''}
						placeholder={isCreatorOrProducer ? 'Give me a name' : ''}
					/>

					<ButtonClose moreClassNames="close-modal-btn" onClick={() => closeModal()} />
				</div>

				<div className="main-area" style={{ marginBottom: '0 !important', paddingBottom: '0 !important' }}>
					<div className="media-modal-center" style={{ margin: '24px' }}>
						<div className="featured-page">
							{graphic
								&& (isVideo(graphic.images)
									? (
										<video
											ref={videoEl}
											src={graphic.images}
											muted={true}
											autoPlay={true}
											loop={typeof graphic.loops === 'number' ? Boolean(graphic.loops) : false}
										/>
									) : (
										<img
											src={graphic.images}
											alt={graphic.title ?? graphic.original_name}
											style={{
												maxWidth: '600px',
												maxHeight: '400px',
												objectFit: 'contain',
											}}
										/>
									)
								)
							}
						</div>
					</div>
				</div>
			</div >
		</>
	);
}
